import React from 'react';
import { Link } from 'react-router-dom';
import { ClipboardList } from 'lucide-react';
import { Button } from './ui/button';
import { enquiryPath } from '../data/enquiry';

/** "Enquire online" CTA that opens /enquiry with the treatment pre-selected. */
const EnquireButton = (props) => {
  const {
    slug,
    about,
    label = 'Enquire online',
    variant = 'outline',
    className = '',
    size = 'lg',
    testId = 'enquire-online-btn',
  } = props;
  const to = enquiryPath(slug, about);

  return (
    <Button size={size} variant={variant} className={className} asChild>
      <Link to={to} data-testid={testId}>
        <ClipboardList className="w-5 h-5 mr-2" aria-hidden="true" />
        {label}
      </Link>
    </Button>
  );
};

export default EnquireButton;
